
import { defineComponent, computed } from "vue";
import type { PropType } from "vue";
import SmallPlayer from "../Player/SmallPlayer.vue";
import { AudioProps } from "../../../composables/types";

export default defineComponent({
  name: "AudioPanel",
  components: {
    SmallPlayer,
  },
  props: {
    audio: {
      type: Object as PropType<AudioProps>,
      required: true,
    },
  },
  setup(props) {
    const audioProps = computed(() => props?.audio);

    return {
      audioProps,
    };
  },
});
